module.exports = __webpack_public_path__ + "img/monastery64_ua.49058f8f.webp";